var map = {
	"./P3-scaled.jpg": "48ac",
	"./Shiba-BG.jpg": "12e1",
	"./aladin.jpg": "a190",
	"./bank/baac.jpg": "e45b",
	"./bank/bankokbank.jpg": "029f",
	"./bank/cimb.jpg": "3a74",
	"./bank/ghbank.jpg": "d1a9",
	"./bank/gsb.jpg": "d79f",
	"./bank/icbc.jpg": "9bed",
	"./bank/kbank.jpg": "25e9",
	"./bank/kiatnakin.jpg": "f79e",
	"./bank/krungsri.jpg": "6827",
	"./bank/ktb.jpg": "ed77",
	"./bank/lh.jpg": "d9be",
	"./bank/scb.jpg": "c6ff",
	"./bank/standard.jpg": "ac03",
	"./bank/tisco.jpg": "3b85",
	"./bank/truewallet.jpg": "6466",
	"./bank/ttb.jpg": "2906",
	"./bank/uob.jpg": "5191",
	"./bank/ธนาคารอิสลาม.jpg": "0387",
	"./cover-casino-bg.jpg": "3c68",
	"./cover-minigame-bg-mobile.jpg": "b22f",
	"./cover-minigame-bg.jpg": "0fdf",
	"./cover-promotion-bg-mobile.jpg": "ce30",
	"./cover-promotion-bg.jpg": "8018",
	"./cover-redeem-bg-mobile.jpg": "79f6",
	"./cover-redeem-bg.jpg": "5a03",
	"./cover-slot-bg-mobile.jpg": "20c6",
	"./cover-slot-bg.jpg": "c691",
	"./ez-theme-switcher-bg.f8595565.jpg": "a9bd",
	"./icon-fb-bttm.jpg": "6d98",
	"./merry.jpg": "eb43",
	"./natural-paper-texture.jpg": "74e8",
	"./rank.jpg": "adbf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b5a1";